import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMssEmail = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_476_46)",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "url(#pattern0_476_46)"
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("pattern", {
			id: "pattern0_476_46",
			patternContentUnits: "objectBoundingBox",
			width: 1,
			height: 1,
			children: /* @__PURE__ */ _jsx("use", {
				href: "#image0_476_46",
				transform: "translate(0 -0.0078125) scale(0.015625)"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_476_46",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("image", {
			id: "image0_476_46",
			width: 64,
			height: 65,
			href: "data:image/png;base64,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"
		})
	] })]
});
export default SvgMssEmail;
